define(['jquery','common'], function ($, ErvCommon) {

	var ERVPostalHelper = function () {
		var self = this;
		self.$ervBody = $('#erv-body');
		self.getCities = false;
		self.common = new ErvCommon();

		self.initEventHandlers = function () {
			if (self.$ervBody.find('#Input_PolicyHolder_PostalCode').length === 1) {
				self.$ervBody.find('#Input_PolicyHolder_PostalCode').on('keyup, blur', self.updateAdress);
				self.getCities = true;
			}
			if (self.$ervBody.find('#Input_PostalCode').length === 1) {
				self.$ervBody.find('#Input_PostalCode').on('keyup, blur', self.updateAdress);
				self.getCities = true;
			}
		};

		self.getCityNames = function () {
			var self = this;
			if (self.getCities) {
				var postalCodesFile = self.common.framework.checks.isDk() ? 'DkZipCodes.js' : 'SeZipCodes.js';

				$.ajax({
					cache: true,
					url: '/assets/dist/script/internal/' + postalCodesFile,
					contentType: "application/json; charset=utf-8",
					dataType: 'json',
					success: function (data) {
						self.cityNames = data.Cities;
					}
				});
			}
		};

		self.autoSelectCountry = function (input) {
			if ($('#AllowCountryAutoSelect').val() !== 'True' || $('#Input_PolicyHolder_CountryCode option').length < 2) {
                return;
            }

			$('#Input_PolicyHolder_CountryCode')
				.val(self.translatePostalCodeToCountryCode(input));
		}

		self.autoSelectClaimsOnlineCountry = function (input) {
			if ($('#AllowClaimsOnlineCountryAutoSelect').val() !== 'true') {
				return;
			}
			
			$('#Input_AddressCountryIsoCode')
				.find(`option[value="${self.common.framework.checks.isDk() ? self.translatePostalCodeToCountryCode(input) : 'SE'}"]`)
				.prop('selected', 'true')
		}

		self.translatePostalCodeToCountryCode = function (input) {
			
			if (input > 0 && input < 1000) {
				return 'FO';
			} else if (input >= 3900 && input < 4000) {
				return 'GL';
			}
			return 'DK';
		}

		self.updateAdress = function (e) {
			var postalInput = $(e.target).val();

			self.autoSelectCountry(+postalInput);

			if (postalInput.length < 4)
				return;

			var postalcleaned = postalInput.replace(/\D/g, '');

			if (self.cityNames !== undefined) {
				$(self.cityNames).each(function (index, value) {
					if (self.cityNames[index].ZipCode === postalcleaned) {
						var cityNameTarget = self.$ervBody.find('[data-js="trigger_postalcode"]');
						$(cityNameTarget).val(value.Name);
						self.autoSelectClaimsOnlineCountry(+postalInput);

						$(cityNameTarget).removeClass('input-validation-error');
						$(cityNameTarget).addClass('input-validation-valid');
						$(cityNameTarget).siblings('span').empty();

						return false;
					}
				});
			}
		};

	};

	ERVPostalHelper.prototype.init = function () {
		var self = this;
		self.initEventHandlers();
		self.getCityNames();
	}

	return ERVPostalHelper;
});